import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { LoginComponent } from '../../features/auth/login/login.component';
import { FooterComponent } from '../../shared/components/footer/footer.component';

@Component({
    selector: 'app-login-layout',
    imports: [RouterOutlet, LoginComponent, FooterComponent],
    templateUrl: './login-layout.component.html',
    styleUrls: ['./login-layout.component.scss']
})
export class LoginLayoutComponent {}
